import { useSelector } from "react-redux";

export default function useDataSource(name) {
    const dataSources  = useSelector(state => state.data.dataSources);

    // console.log('useDataSource:{0}'.format(name));
    // console.log(dataSources);

    let dataSource = dataSources.find(s => s.name.toLowerCase().trim() === name.toLowerCase().trim());

    // Mock up DS
    if (!dataSource) {
        if (name.toLowerCase().indexOf('ignore') < 0) {
            // console.log("**WARN** DataSource '{0}' was not found or configured".format(name));
        }
        dataSource = {
            data: null,
            fetched: false,
            fetching: false,
            error: null
        }
    }
    return dataSource;
}
